import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const role = createCrudVuexModule({
  namespaced: true,
  path: "/role",
});

export const managementRole = createCrudVuexModule({
  namespaced: true,
  path: "/management/role",
  actions: {
    async create({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.post("/management/role", payload);
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async update({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.put("/management/role", payload);

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
export const managementPermission = createCrudVuexModule({
  namespaced: true,
  path: "/management/permission",
  state: {
    permissions: [],
  },
  getters: {
    permissions: (state) => state.permissions,
  },
  mutations: {
    permissions: (state, value) => (state.permissions = value),
  },
  actions: {
    async fetchAll({ commit }) {
      commit("isLoading", true);
      try {
        commit("permissions", []);
        const response = await rest.get(`/management/permission`);
        commit("permissions", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
  },
});
